export default function(arr, func) {
  let result = []
  arr.forEach((el) => {
    result.push(func(el))
  })
  return result
}